

























































import QRCode from 'qrcode';
import type { PropType } from '@vue/composition-api';
import { watch, onMounted, computed, ref, defineComponent } from '@vue/composition-api';
import type { BankId } from '../../../types/bankid';
import { HintCodePending } from '../../../types/enums/bankid-se';

export default defineComponent({
  props: {
    bankId: {
      type: Object as PropType<BankId>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const qrcodeUrl = ref('');

    watch(
      () => props.bankId.autoStartToken,
      () => {
        generateQR();
      }
    );

    const isSigning = computed(() => props.bankId.hintCode === HintCodePending.userSign);
    const autoStartToken = computed(() => props.bankId?.autoStartToken);

    const generateQR = async () => {
      try {
        qrcodeUrl.value = await QRCode.toDataURL(
          `bankid:///?autostarttoken=${autoStartToken.value}`
        );
      } catch (err) {
        qrcodeUrl.value = '';
      }
    };

    const handleSetSSN = () => {
      emit('setSSN');
    };

    onMounted(() => {
      generateQR();
    });

    return {
      qrcodeUrl,
      handleSetSSN,
      isSigning,
      autoStartToken,
      generateQR,
    };
  },
});
